<template>
<div class="chapter">
<div class="inner_page">
<div class="dedicationPage">
<a id="title17"></a>
<div class="p-c"><span><em class="i">For my mother and father, Alice and William Page,<br/> who first brought me to the island</em></span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781466806597_ded01.vue?c97fb988